// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"777":"8f22d648","803":"9bcb2f4c"}[chunkId] + ".chunk.css";
};